import { useGetLeads } from '@services/leads/useGetLeads'

const MAX_LEADS_COUNT = 999
const LEADS_COUNT_EXCEEDED_LABEL = '+999'

export const useUnreadLeads = () => {
  const { data: unreadLeadsList, mutate: refreshUnreadLeadsList } = useGetLeads(
    {
      pageSize: 1,
      page: 0,
      is_read: 0
    }
  )

  const totalLeadsCount = unreadLeadsList?.pagination?.counter?.total ?? 0

  const isMaxLeadsCountExceeded = totalLeadsCount > MAX_LEADS_COUNT

  const leadCount = isMaxLeadsCountExceeded
    ? LEADS_COUNT_EXCEEDED_LABEL
    : totalLeadsCount

  return { leadCount, refreshUnreadLeadsList }
}
